import React from "react";
import Cookies from "js-cookie";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Protected from "./Protected";
import Login from "../Auth/Login";
import DashBoard from "../DashBoard/DashBoard";
import Layout from "./Layout";
import ForgotPassword from "../Auth/ForgotPassword";
import AddUser from "../Admin/AddUser";
import Compliances from "../OfficeRelated/Compliances/Compliances";
import ResetPassword from "../Auth/ResetPassword";
import RawMaterialDetails from "../Manufacturing/RawMaterial/RawMaterialDetails";
import CompanyDetails from "../CompanyDetails/CompanyDetails";
import MaterialIncoming from "../Manufacturing/RawMaterial/MaterialIncoming";
import NotificationHistory from "../NotificationHistory/NotificationHistory";
import Error from "../Common/Error/Error";
import OrderDetails from "../Manufacturing/OrderDetails/OrderDetails";
import GovtOrderDetails from "../Manufacturing/GovtOrderDetails/GovtOrderDetails";
import Products from "../Manufacturing/Products/Products";
import StaffDetails from "../OfficeRelated/StaffDetails/StaffDetails";
import OfficeUtils from "../OfficeRelated/OfficeUtils/OfficeUtils";
import StaffSalary from "../OfficeRelated/StaffSalary/StaffSalary";
import PartyName from "../Manufacturing/PartyNameDetails/PartyName";
import ProductDetails from "../Manufacturing/Products/ProductsDetails/ProductDetails";
import MaterialConsumptionVal from "../Manufacturing/MaterialConsumption/MaterialConsumptionVal";
import MisReport from "../Manufacturing/MisReport/MisReport";
import MaterialName from "../Manufacturing/MaterialName/MaterialName";
import CompanyYard from "../OrderDetials/CompanyYard/CompanyYard";
import YardDetails from "../OrderDetials/YardDetails/YardDetails";
import GovtOrder from "../OrderDetials/GovtOrder/GovtOrder";
import AddPrivateOrder from "../OrderDetials/TKCSOrder/AddTKCSOrder";
import AddGovtOrder from "../OrderDetials/GovtOrder/AddGovtOrder";
import ViewGovtOrder from "../OrderDetials/GovtOrder/ViewGovtOrder";
import ViewOrderDetails from "../OrderDetials/GovtOrder/ViewOrderDetails";
import UpdateGovtOrder from "../OrderDetials/GovtOrder/UpdateGovtOrder";
import UpdateGovtOrderDetails from "../OrderDetials/GovtOrder/UpdateGovtOrderDetails";
import RateList from "../OrderDetials/RateList/RateList";
import ViewPrivateLocalDetails from "../OrderDetials/PrivateLocalOrder/ViewPrivateLocalDetails";
import TKCSOrderDetails from "../OrderDetials/TKCSOrder/TKCSOrderDetails";
import ViewTKCSOrder from "../OrderDetials/TKCSOrder/ViewTKCSOrder";
import ViewTKCSOrderDetails from "../OrderDetials/TKCSOrder/ViewTKCSOrderDetails";
import DiscomList from "../OrderDetials/DiscomList/DiscomList";
import RegionList from "../OrderDetials/RegionList/RegionList";
import GovtRateList from "../OrderDetials/GovtCircleRateList/GovtRateList";
import TKCSRateList from "../OrderDetials/TKCSRateList/TKCSRateList";
import PrivateRateList from "../OrderDetials/PrivateRate/PrivateRateList";
import GovtOrderDispatch from "../Supply/GovtOrderDispatch/GovtOrderDispatch";
import GovtOrderNumberetails from "../Supply/GovtOrderDispatch/GovtOrderNumberDetails";
import PrivatePartyOrder from "../Supply/PrivateOrderDispatch/PrivatePartyOrder";
import PrivateOrderDispatch from "../Supply/PrivateOrderDispatch/PrivateOrderDispatch";
import TKCSOrderNumberDispatch from "../Supply/TKCSOrderDispatch/TKCSOrderNumberDispatch";
import TKCSOrderDispatch from "../Supply/TKCSOrderDispatch/TKCSOrderDispatch";
import VehicleDetails from "../Logistics/VehicleDetails/VehicleDetails";
import BatteryDetails from "../Logistics/BatteryDetails/BatteryDetails";
import TyreDetails from "../Logistics/TyreDetails/TyreDetails";
import VehicleUtilities from "../Logistics/Utilities/VehicleUtilities";
import TruckDocument from "../Logistics/TruckDocument/TruckDocument";
import PumpDetails from "../Logistics/PumpDetails/PumpDetails";
import TripDetails from "../Supply/TripDetails/TripDetails";
import TripDispatchDetails from "../Supply/TripDetails/TripDispatchDetails";
import MaterialOrderDispatch from "../Supply/MaterialDispatch/MaterialOrderDispatch";
const AllRoutes = ({ onCallFullScreen }) => {
  const token = Cookies.get("token");
  const isAuthenticated = token !== null;
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        {isAuthenticated ? (
          <>
            <Route
              path="/dashboard"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <DashBoard />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/adduser"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <AddUser />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/compliances"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <Compliances />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/raw-material-details"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <RawMaterialDetails />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/raw-material-name"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <MaterialIncoming />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/company-details"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <CompanyDetails />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/notification-history"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <NotificationHistory />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/order-details"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <OrderDetails />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/govt-order-details"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <GovtOrderDetails />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/products"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <Products />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/staff-details"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <StaffDetails />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/office-utils"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <OfficeUtils />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/staff-salary"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <StaffSalary />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/party-name"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <PartyName />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/products-details"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <ProductDetails />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/material-consumption"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <MaterialConsumptionVal />
                  </Layout>
                </Protected>
              }
            />
            {/* <Route
              path="/mis-report/:date"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <MisReport/>
                  </Layout>
                </Protected>
              }
            /> */}
            <Route
              path="/material-name"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <MaterialName />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/company-yard"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <CompanyYard />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/yard-details"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <YardDetails />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/add-private-order"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <AddPrivateOrder />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/TKCS-order-detials"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <TKCSOrderDetails />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/view-TKCS-order-detials/:order_id"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <ViewTKCSOrder />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/govt-order"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <GovtOrder />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/view-private-order"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <ViewPrivateLocalDetails />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/add-govt-order"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <AddGovtOrder />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/view-govt-order/:order_id"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <ViewGovtOrder />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/view-govt-order_details/:order_id"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <ViewOrderDetails />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/update-govt-order"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <UpdateGovtOrder />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/update-govt-order-details"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <UpdateGovtOrderDetails />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/rate-list"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <RateList />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/discom-list"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <DiscomList />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/view-TKCS-order_details_number/:order_id"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <ViewTKCSOrderDetails />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/region-list"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <RegionList />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/govt-rate-list"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <GovtRateList />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/tkcs-rate-list"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <TKCSRateList />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/private-rate-list"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <PrivateRateList />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/govt-order-number"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <GovtOrderNumberetails />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/govt-order-dispatch/:id"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <GovtOrderDispatch />
                  </Layout>
                </Protected>
              }
            />

            <Route
              path="/private-order-party-name"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <PrivatePartyOrder />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/material-dispatch"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <MaterialOrderDispatch />
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/private-order-dispatch/:id"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <PrivateOrderDispatch/>
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/tkcs-order-number-dispatch"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <TKCSOrderNumberDispatch/>
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/tkcs-number-dispatch/:id"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <TKCSOrderDispatch/>
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/trip-dipatch-details/:id"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <TripDispatchDetails/>
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/vehicle-details"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <VehicleDetails/>
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/battery-details"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <BatteryDetails/>
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/tyre-details"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <TyreDetails/>
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/vehicle-utilities"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <VehicleUtilities/>
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/truck-document"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <TruckDocument/>
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/pump-details"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <PumpDetails/>
                  </Layout>
                </Protected>
              }
            />
            <Route
              path="/trip-details"
              element={
                <Protected>
                  <Layout onCallFullScreen={onCallFullScreen}>
                    <TripDetails/>
                  </Layout>
                </Protected>
              }
            />
            <Route path="*" element={<Error />} />
          </>
        ) : null}
      </Routes>
    </BrowserRouter>
  );
};

export default AllRoutes;
